<!-- @format -->

<template>
  <div class="ui">
    <div v-if="!getRiskToleranceResponse">
      <div class="ui segment">
        <div class="ui flexible grid">
          <div class="ui seven wide column" style="text-align: center">
            <a href="#" @click.prevent="initialSelection(false)">
              <Section
                :style="'[adding: ]; font-weight: bold;font-size: 1.3em;'"
                >Questionnaire

                <br /><span style="font-size: small"
                  >six questions</span
                ></Section
              ></a
            >
          </div>
          <div class="ui centered two wide column" style="text-align: center">
            <Section
              :style="'font-weight: bold;font-size: 1.3em; background-color: white'"
            >
              OR
            </Section>
          </div>
          <div class="ui seven wide column" style="text-align: center">
            <a href="#" @click.prevent="initialSelection(true)"
              ><Section :style="'font-weight: bold;font-size: 1.3em;'">
                Manual <br />

                <span style="font-size: small">subjective judgment</span>
              </Section></a
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="">
        <div class="ui segment">
          <div class="ui grid">
            <div class="ui seven wide column" style="text-align: center">
              <a href="#" @click.prevent="overrideRiskProfile = false">
                <Section
                  :style="
                    !overrideRiskProfile
                      ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold; font-size: 1.3em;color: black;cursor: text'
                      : '[adding: ]; font-weight: bold;font-size: 1.3em;'
                  "
                  >Questionnaire
                  <i v-if="!overrideRiskProfile" class="ui icon check"></i>
                  <br /><span style="font-size: small"
                    >six questions</span
                  ></Section
                ></a
              >
            </div>
            <div class="ui two wide column" style="text-align: center">
              <Section
                :style="'background-color: white; font-weight: bold;font-size: 1.3em;'"
                >OR</Section
              >
            </div>
            <div class="ui seven wide column" style="text-align: center">
              <a href="#" @click.prevent="overrideRiskProfile = true"
                ><Section
                  :style="
                    overrideRiskProfile
                      ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold; font-size: 1.3em; color: black;cursor: text'
                      : 'font-weight: bold; font-size: 1.3em'
                  "
                >
                  Manual
                  <i v-if="overrideRiskProfile" class="ui icon check"></i><br />
                  <span style="font-size: small">subjective judgment</span>
                </Section></a
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="!overrideRiskProfile" class="ui row">
        <br />
        <div class="ui column">
          <div class="ui attached message">
            <h4>Behavioural Loss Tolerance Scoring Sheet</h4>
          </div>
          <div class="ui attached segment">
            <sui-form>
              <Section style="background-color: rgba(150, 173, 216, 0.2)"
                ><strong for="willingnessToTakeRisk"
                  >1. What is the investor’s risk tolerance or willingness to
                  take financial risk?</strong
                ></Section
              >
              <Section
                style="
                  background-color: rgba(242, 242, 242, 0.7);
                  margin-bottom: 0;
                "
              >
                <div class="ui five column grid">
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="willingnessToTakeRisk"
                        name="willingnessToTakeRisk"
                        label="Very Low"
                        :value="1"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="willingnessToTakeRisk"
                        name="willingnessToTakeRisk"
                        label="Low"
                        :value="2"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="willingnessToTakeRisk"
                        name="willingnessToTakeRisk"
                        label="Moderate"
                        :value="3"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="willingnessToTakeRisk"
                        name="willingnessToTakeRisk"
                        label="High"
                        :value="4"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="willingnessToTakeRisk"
                        name="willingnessToTakeRisk"
                        label="Very High"
                        :value="5"
                      />
                    </sui-form-field>
                  </div>
                </div>
              </Section>
              <div class="ui divider"></div>
              <Section style="background-color: rgba(150, 173, 216, 0.2)"
                ><strong for="preferencesWhenHoldingRiskAssets"
                  >2. What is the investor’s preference when holding risky
                  assets?</strong
                ></Section
              >
              <Section style="background-color: rgba(242, 242, 242, 0.7)">
                <div class="ui five column grid">
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="preferencesWhenHoldingRiskAssets"
                        name="preferencesWhenHoldingRiskAssets"
                        label="Maximise Safety"
                        :value="1"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="preferencesWhenHoldingRiskAssets"
                        name="preferencesWhenHoldingRiskAssets"
                        label="Mostly Safety"
                        :value="2"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="preferencesWhenHoldingRiskAssets"
                        name="preferencesWhenHoldingRiskAssets"
                        label="Mix of Safety and Return"
                        :value="3"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="preferencesWhenHoldingRiskAssets"
                        name="preferencesWhenHoldingRiskAssets"
                        label="Mostly Return"
                        :value="4"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="preferencesWhenHoldingRiskAssets"
                        name="preferencesWhenHoldingRiskAssets"
                        label="Maximise Return"
                        :value="5"
                      />
                    </sui-form-field>
                  </div></div
              ></Section>
              <div class="ui divider"></div>
              <Section style="background-color: rgba(150, 173, 216, 0.2)"
                ><strong for="knowledgeable"
                  >3. How knowledgeable is the investor about financial and
                  investment concepts?</strong
                ></Section
              >
              <Section style="background-color: rgba(242, 242, 242, 0.7)">
                <div class="ui five column grid">
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="knowledgeable"
                        name="knowledgeable"
                        label="Not at All Knowledgeable"
                        :value="1"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="knowledgeable"
                        name="knowledgeable"
                        label="Minimally Knowledgeable"
                        :value="2"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="knowledgeable"
                        name="knowledgeable"
                        label="Moderately Knowledgeable"
                        :value="3"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="knowledgeable"
                        name="knowledgeable"
                        label="Competent"
                        :value="4"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="knowledgeable"
                        name="knowledgeable"
                        label="Very Knowledgeable"
                        :value="5"
                      />
                    </sui-form-field>
                  </div></div
              ></Section>
              <div class="ui divider"></div>
              <Section style="background-color: rgba(150, 173, 216, 0.2)"
                ><strong for="experience"
                  >4. How much experience does the investor have with investment
                  products?</strong
                ></Section
              >
              <Section style="background-color: rgba(242, 242, 242, 0.7)">
                <div class="ui five column grid">
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="experience"
                        name="experience"
                        label="None"
                        :value="1"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="experience"
                        name="experience"
                        label="Very little"
                        :value="2"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="experience"
                        name="experience"
                        label="Some"
                        :value="3"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="experience"
                        name="experience"
                        label="Modest"
                        :value="4"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="experience"
                        name="experience"
                        label="Extensive"
                        :value="5"
                      />
                    </sui-form-field>
                  </div></div
              ></Section>
              <div class="ui divider"></div>
              <Section style="background-color: rgba(150, 173, 216, 0.2)"
                ><strong for="perceptionOfStockMarket"
                  >5. What is the investor’s perception of the riskiness of the
                  stock market?</strong
                ></Section
              >
              <Section style="background-color: rgba(242, 242, 242, 0.7)">
                <div class="ui five column grid">
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="perceptionOfStockMarket"
                        name="perceptionOfStockMarket"
                        label="Very Risky"
                        :value="1"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="perceptionOfStockMarket"
                        name="perceptionOfStockMarket"
                        label="Somewhat Risky"
                        :value="2"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="perceptionOfStockMarket"
                        name="perceptionOfStockMarket"
                        label="Neutral"
                        :value="3"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="perceptionOfStockMarket"
                        name="perceptionOfStockMarket"
                        label="Somewhat Safe"
                        :value="4"
                      />
                    </sui-form-field>
                  </div>
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="perceptionOfStockMarket"
                        name="perceptionOfStockMarket"
                        label="Very safe"
                        :value="5"
                      />
                    </sui-form-field>
                  </div></div
              ></Section>
              <div class="ui divider"></div>
              <Section style="background-color: rgba(150, 173, 216, 0.2)"
                ><strong for="pastInvestmentLosses"
                  >6. In the past, when faced with investment losses, what
                  action did the investor take?
                </strong></Section
              >
              <Section style="background-color: rgba(242, 242, 242, 0.7)">
                <div class="ui five column grid">
                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="pastInvestmentLosses"
                        name="pastInvestmentLosses"
                        label="Sold Investment"
                        :value="1"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="pastInvestmentLosses"
                        name="pastInvestmentLosses"
                        label="Did Nothing"
                        :value="3"
                      />
                    </sui-form-field>
                  </div>

                  <div class="ui column">
                    <sui-form-field>
                      <sui-checkbox
                        radio
                        v-model.number="pastInvestmentLosses"
                        name="pastInvestmentLosses"
                        label="Purchased More"
                        :value="5"
                      />
                    </sui-form-field>
                  </div></div
              ></Section>
            </sui-form>
          </div>
          <div class="ui bottom attached message">
            <p>
              <strong>Total Score: {{ totalScore }}</strong>
            </p>
          </div>
          <div class="ui segment">
            <div class="ui equal width grid">
              <div class="ui equal width row">
                <div class="ui column" style="text-align: center">
                  <Section
                    :style="
                      totalScore >= 6 && totalScore <= 10
                        ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold'
                        : ''
                    "
                    >LOW = 6 to 10</Section
                  >
                </div>
                <div class="ui column" style="text-align: center">
                  <Section
                    :style="
                      totalScore >= 11 && totalScore <= 15
                        ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold'
                        : ''
                    "
                    >MOD-LOW = 11 to 15</Section
                  >
                </div>
                <div class="ui column" style="text-align: center">
                  <Section
                    :style="
                      totalScore >= 16 && totalScore <= 20
                        ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold'
                        : ''
                    "
                    >MODERATE = 16 to 20</Section
                  >
                </div>
                <div class="ui column" style="text-align: center">
                  <Section
                    :style="
                      totalScore >= 21 && totalScore <= 25
                        ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold'
                        : ''
                    "
                    >MOD-HIGH = 21 to 25</Section
                  >
                </div>
                <div class="ui column" style="text-align: center">
                  <Section
                    :style="
                      totalScore >= 26 && totalScore <= 30
                        ? 'background-color: rgba(80, 180, 80, 0.2); font-weight: bold'
                        : ''
                    "
                    >HIGH = 26 to 30</Section
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="overrideRiskProfile" class="ui row">
        <br />
        <div class="ui column">
          <div class="ui attached message">
            <h4>
              Subjective Assessment of Investor's Behavioural Loss Tolerance
            </h4>
          </div>

          <div class="ui attached segment">
            <v-select
              label="riskProfileName"
              @input="handleRiskChanged"
              :reduce="(op) => op.id"
              v-model="overrideRiskProfileId"
              :options="riskProfiles"
            >
              <template v-slot:option="option">{{
                option.riskProfileName
              }}</template>
            </v-select>
            <br />
            <div class="ui form">
              <div class="field">
                <label>(optional) Notes</label>
                <textarea v-model="overrideMessage" rows="5"></textarea>
              </div>
              <small>
                Source: CFA "elements of behavioral loss tolerance tend to be
                subjective and unique to each investor"</small
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import "vue-select/dist/vue-select.css";
import { getRiskProfiles, getRiskTolerance } from "@/gateway.js";
export default {
  name: "GoalTypes",
  components: { vSelect, VueSlider },
  props: ["currency", "goalRiskProfile", "getRiskToleranceResponse"],
  data() {
    return {
      overrideRiskProfileId: null,
      riskProfileId: null,
      riskProfiles: [],
      overrideMessage:
        "The behavioural loss tolerance has been subjectively evaluated based on the discussions with the client",
      overrideRiskProfile: false,
      willingnessToTakeRisk: 1,
      preferencesWhenHoldingRiskAssets: 1,
      knowledgeable: 1,
      experience: 1,
      perceptionOfStockMarket: 1,
      pastInvestmentLosses: 1,
      // getRiskToleranceResponse: null
    };
  },
  computed: {
    totalScore() {
      return (
        parseInt(this.willingnessToTakeRisk) +
        parseInt(this.preferencesWhenHoldingRiskAssets) +
        parseInt(this.knowledgeable) +
        parseInt(this.experience) +
        parseInt(this.perceptionOfStockMarket) +
        parseInt(this.pastInvestmentLosses)
      );
    },
  },
  watch: {
    totalScore(newValue) {
      //  alert(`yes, computed property changed: ${newValue}`);
      console.log("handling risk via wathc");
      if (this.totalScore >= 6) this.handleRiskChanged();
    },
    overrideRiskProfile(newValue) {
      this.handleRiskChanged();
    },
    overrideMessage(newValue) {
      this.handleNoteChanged();
    },
  },
  methods: {
    async initialSelection(override) {
      this.overrideRiskProfile = override;
      this.init();
    },
    async handleRiskChanged() {
      /* if (
         (parseInt(this.willingnessToTakeRisk) > 0 &&
          parseInt(this.preferencesWhenHoldingRiskAssets) > 0 &&
          parseInt(this.knowledgeable) > 0 &&
          parseInt(this.experience) > 0 &&
          parseInt(this.perceptionOfStockMarket) > 0 &&
          parseInt(this.pastInvestmentLosses) > 0) ||
       this.overrideRiskProfile == true
      )*/ {
        var response = await getRiskTolerance({
          currency: this.currency,
          overrideMessage: this.overrideMessage,
          overrideRiskProfileId: this.overrideRiskProfileId,
          willingnessToTakeRisk: this.willingnessToTakeRisk,
          preferencesWhenHoldingRiskAssets: this
            .preferencesWhenHoldingRiskAssets,
          knowledgeable: this.knowledgeable,
          experience: this.experience,
          perceptionOfStockMarket: this.perceptionOfStockMarket,
          pastInvestmentLosses: this.pastInvestmentLosses,
          override: this.overrideRiskProfile,
        });
        if (response) {
          this.getRiskToleranceResponse = response;
          this.goalRiskProfile.getRiskToleranceResponse = response;
        }
      }
    },
    async handleNoteChanged() {
      this.goalRiskProfile.getRiskToleranceResponse.overrideMessage = this.overrideMessage;
    },
    async init() {
      var response = await getRiskProfiles({ currency: this.currency });
      if (response) {
        this.riskProfiles = response.result;
      }

      if (this.goalRiskProfile.getRiskToleranceResponse) {
        this.overrideRiskProfileId = this.goalRiskProfile.getRiskToleranceResponse.overrideRiskProfileId;
        this.overrideRiskProfile = this.goalRiskProfile.getRiskToleranceResponse.override;
        this.overrideMessage = this.goalRiskProfile.getRiskToleranceResponse.overrideMessage;

        this.willingnessToTakeRisk = this.goalRiskProfile.getRiskToleranceResponse.willingnessToTakeRisk;
        this.knowledgeable = this.goalRiskProfile.getRiskToleranceResponse.knowledgeable;
        this.experience = this.goalRiskProfile.getRiskToleranceResponse.experience;
        this.perceptionOfStockMarket = this.goalRiskProfile.getRiskToleranceResponse.perceptionOfStockMarket;
        this.preferencesWhenHoldingRiskAssets = this.goalRiskProfile.getRiskToleranceResponse.preferencesWhenHoldingRiskAssets;
        this.pastInvestmentLosses = this.goalRiskProfile.getRiskToleranceResponse.pastInvestmentLosses;

        this.riskProfileId = this.goalRiskProfile.riskProfile.id;
      } else {
        await this.handleRiskChanged();
      }
    },
  },
  mounted() {
    if (this.getRiskToleranceResponse) this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
